import { LoggerService } from "@Front/Services/LoggerService/LoggerService";

/**
 * IdNot sets Content-Security-Policy frame-ancestors (often 'self'); loading their logout
 * URL in a hidden iframe fails and can surface as chrome-error://chromewebdata.
 * Local session is cleared by callers; OAuth authorize already uses prompt=login.
 */
export async function reportIdNotRemoteLogoutSkipped(context: string): Promise<void> {
	LoggerService.info("ℹ️ [IdNot] Déconnexion IdNot distante non tentée (iframe incompatible CSP)", {
		context,
		detail:
			"Les pages IdNot refusent l'affichage dans un cadre tiers. Nettoyage local effectué ; la prochaine authentification IdNot repart sur l'écran de connexion grâce à prompt=login.",
	});
}
